import { render, staticRenderFns } from "./ChooseGraphics.vue?vue&type=template&id=2949425c&scoped=true&"
import script from "./ChooseGraphics.vue?vue&type=script&lang=js&"
export * from "./ChooseGraphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2949425c",
  null
  
)

export default component.exports